import { generateScholarshipGrantOverview } from './scholarshipGrantPDF';
import { generateCausePortfolioOverview } from './causePortfolioPDF';
import { generateNILFoundationOverview, generateNILFiscalSponsorshipGuide } from './nilAthletePDF';
import { generateDynamicImpactOverview } from './dynamicImpactPDF';
import { generateCorporatePhilanthropyOverview } from './corporatePhilanthropyPDF';
import { generateDonorAdvisedFundsOverview } from './donorAdvisedFundsPDF';
import { generateSubscriptionBasedGivingOverview } from './subscriptionBasedGivingPDF';
import { generateCrowdfundingFiscalSponsorshipOverview } from './crowdfundingFiscalSponsorshipPDF';
import { generateSportsProgramsOverview } from './sportsProgramsPDF';
import { generateCommunityBasedProgramsOverview } from './communityBasedProgramsPDF';
import { generateAfterSchoolEducationProgramsOverview } from './afterSchoolEducationProgramsPDF';
import { generateDisasterReliefProgramsOverview } from './disasterReliefProgramsPDF';
import { generateDocumentaristsOverview } from './fiscalSponsorshipDocumentaristsPDF';
import { generateArtsCreativeIndustriesOverview } from './artsCreativeIndustriesPDF';
import { generateStrategicPartnershipsOverview } from './strategicPartnershipsAlliancesPDF';
import { generateEnvironmentalInitiativesOverview } from './environmentalClimateInitiativesPDF';
import { generateTechnologySolutionsOverview } from './technologySolutionsPDF';
import { generateOperationalComplianceOverview } from './operationalComplianceStrategiesPDF';
import { generateGrantPolicyReportingOverview } from './grantPolicyReportingPDF';
import { generateGrantFindingApplicationOverview } from './grantFindingApplicationPDF';
import { generateFundraisingStrategiesOverview } from './fundraisingStrategiesPDF';
import { generateFiscalSponsorshipOverview } from './fiscalSponsorshipPDF';
import { generateFiscalSponsorshipDefinitiveGuide } from './fiscalSponsorshipDefinitiveGuidePDF';
import { generateMedicalResearchOverview } from './medicalResearchPDF';
import { generateAccountingGuidanceOverview } from './accountingGuidancePDF';
import { generateCRFGuide } from './charitableRemainderFundsPDF';
import { FaFilm, FaBookOpen, FaTasks, FaShieldAlt, FaDonate, FaGraduationCap, FaUniversity, 
         FaMedal, FaUsers, FaSchool, FaHandHoldingHeart, FaPaintBrush, FaLeaf, FaLaptopCode, 
         FaBalanceScale, FaSearchDollar, FaChartLine, FaHandshake, FaLightbulb, FaRegBuilding, 
         FaUserGraduate, FaRegCalendarAlt, FaRunning, FaSearch, FaHandHoldingUsd,FaProjectDiagram, FaHeart, FaGlobe, FaHandsHelping, FaBuilding, FaHeartbeat, FaCalculator,
         FaPalette, FaDollarSign,FaMoneyBillWave, FaBullseye, FaUserTie, FaChild, FaCogs, 
         FaHardHat} from 'react-icons/fa';
import { GiSurroundedShield, GiTechnoHeart, GiTakeMyMoney } from 'react-icons/gi';
import { PiStudentBold } from 'react-icons/pi';
import { FaComputer } from 'react-icons/fa6';
import { generateEducationalPDF, generateFiscalSponsorship101 } from './educationalPDFGenerator';

// Resource categories with descriptions for UI
export const resourceCategories = {
  EDUCATIONAL: {
    id: 'educational',
    title: 'Educational Resources',
    description: 'Comprehensive guides and frameworks for educational programs and initiatives',
    icon: <FaGraduationCap />
  },
  OPERATIONAL: {
    id: 'operational',
    title: 'Operational Excellence',
    description: 'Tools and guides for efficient nonprofit operations',
    icon: <FaTasks />
  },
  COMPLIANCE: {
    id: 'compliance',
    title: 'Compliance & Reporting',
    description: 'Essential guidelines for maintaining regulatory compliance',
    icon: <FaShieldAlt />
  },
  FUNDRAISING: {
    id: 'fundraising',
    title: 'Fundraising Solutions',
    description: 'Strategic approaches to sustainable fundraising',
    icon: <FaDonate />
  },
  FISCAL_SPONSORSHIP: {
    id: 'fiscal_sponsorship',
    title: 'Fiscal Sponsorship',
    description: 'Comprehensive fiscal sponsorship programs and guidelines',
    icon: <FaRegBuilding />
  },
  ACCOUNTING: {
    id: 'accounting',
    title: 'Accounting',
    description: 'Essential guidance for nonprofit accounting and financial compliance',
    icon: <FaCalculator />
  },
  ARTS: {
    id: 'arts',
    title: 'Arts',
    description: 'Comprehensive guide for artists and creative projects',
    icon: <FaPalette />
  },
  ATHLETES: {
    id: 'athletes',
    title: 'Athletes',
    description: 'Guide for managing NIL athlete foundations',
    icon: <FaMedal />
  },
  CSR: {
    id: 'csr',
    title: 'CSR',
    description: 'Comprehensive guide to strategic corporate giving and CSR implementation',
    icon: <FaHandshake />
  },
  CAUSE_MANAGEMENT: {
    id: 'cause_management',
    title: 'Cause Management',
    description: 'Strategic framework for managing multiple charitable initiatives',
    icon: <FaHeart />
  },
  COMMUNITY: {
    id: 'community',
    title: 'Community',
    description: 'Guide for developing community-based programs',
    icon: <FaUsers />
  },
  CREATIVE: {
    id: 'creative',
    title: 'Creative',
    description: 'Comprehensive guide for artists and creative projects',
    icon: <FaPaintBrush />
  },
  DISASTER: {
    id: 'disaster',
    title: 'Disaster',
    description: 'Guide for managing disaster relief programs',
    icon: <FaHandHoldingHeart />
  },
  DOCUMENTARY: {
    id: 'documentary',
    title: 'Documentary',
    description: 'Funding and compliance guide for film projects',
    icon: <FaFilm />
  },
  ENVIRONMENTAL: {
    id: 'environmental',
    title: 'Environmental',
    description: 'Guide for environmental and climate initiatives',
    icon: <FaLeaf />
  },
  TECHNOLOGY: {
    id: 'technology',
    title: 'Technology',
    description: 'Strategic guide to next-generation technology infrastructure',
    icon: <FaLaptopCode />
  },
  TECHNOLOGY_INTEGRATION: {
    id: 'technology_integration',
    title: 'Technology Integration',
    description: 'Revolutionary guide redefining fiscal sponsorship for the digital age, introducing pioneering frameworks for compliance, risk management, and scaled impact.',
    icon: <FaLaptopCode />
  },
  PROGRAMS: {
    id: 'programs',
    title: 'Programs',
    description: 'Guide for managing sports programs',
    icon: <FaProjectDiagram />
  },
  YOUTH: {
    id: 'youth',
    title: 'Youth',
    description: 'Guide for managing after-school education programs',
    icon: <FaChild />
  }
};

// First, define the resource types as an exported constant
export const RESOURCE_TYPES = {
  AFTER_SCHOOL: 'afterSchoolEducation',
  COMMUNITY: 'communityBasedPrograms',
  DOCUMENTARISTS: 'documentarists',
  OPERATIONAL_COMPLIANCE: 'operationalCompliance',
  STRATEGIC_PARTNERSHIPS: 'strategicPartnerships',
  TECHNOLOGY_SOLUTIONS: 'technologySolutions',
  GRANT_FINDING: 'grantFinding',
  GRANT_POLICY: 'grantPolicy',
  FUNDRAISING_STRATEGIES: 'fundraisingStrategies',
  DONOR_ADVISED_FUNDS: 'donorAdvisedFunds',
  SUBSCRIPTION_GIVING: 'subscriptionGiving',
  CORPORATE_PHILANTHROPY: 'corporatePhilanthropy',
  CROWDFUNDING: 'crowdfundingFiscalSponsorship',
  FISCAL_SPONSORSHIP: 'fiscalSponsorship',
  NIL_GUIDE: 'nilFiscalSponsorshipGuide',
  FISCAL_SPONSORSHIP_DEFINITIVE: 'fiscalSponsorshipDefinitiveGuide',
  // Add any missing resource types here
};

// Define the generators map
const generators = {
  [RESOURCE_TYPES.AFTER_SCHOOL]: generateAfterSchoolEducationProgramsOverview,
  [RESOURCE_TYPES.COMMUNITY]: generateCommunityBasedProgramsOverview,
  [RESOURCE_TYPES.DOCUMENTARISTS]: generateDocumentaristsOverview,
  [RESOURCE_TYPES.OPERATIONAL_COMPLIANCE]: generateOperationalComplianceOverview,
  [RESOURCE_TYPES.STRATEGIC_PARTNERSHIPS]: generateStrategicPartnershipsOverview,
  [RESOURCE_TYPES.TECHNOLOGY_SOLUTIONS]: generateTechnologySolutionsOverview,
  [RESOURCE_TYPES.GRANT_FINDING]: generateGrantFindingApplicationOverview,
  [RESOURCE_TYPES.GRANT_POLICY]: generateGrantPolicyReportingOverview,
  [RESOURCE_TYPES.FUNDRAISING_STRATEGIES]: generateFundraisingStrategiesOverview,
  [RESOURCE_TYPES.DONOR_ADVISED_FUNDS]: generateDonorAdvisedFundsOverview,
  [RESOURCE_TYPES.SUBSCRIPTION_GIVING]: generateSubscriptionBasedGivingOverview,
  [RESOURCE_TYPES.CORPORATE_PHILANTHROPY]: generateCorporatePhilanthropyOverview,
  [RESOURCE_TYPES.CROWDFUNDING]: generateCrowdfundingFiscalSponsorshipOverview,
  [RESOURCE_TYPES.FISCAL_SPONSORSHIP]: generateFiscalSponsorshipOverview,
  [RESOURCE_TYPES.NIL_GUIDE]: generateNILFiscalSponsorshipGuide,
  [RESOURCE_TYPES.FISCAL_SPONSORSHIP_DEFINITIVE]: generateFiscalSponsorshipDefinitiveGuide,
};


// Update the handlePDFGeneration function
export const handlePDFGeneration = async (resourceType, resource) => {
  try {
    console.log('Attempting to generate PDF for:', resourceType);

    if (!resourceType) {
      throw new Error('Resource type is required');
    }

    if (!RESOURCE_TYPES[resourceType] && !Object.values(RESOURCE_TYPES).includes(resourceType)) {
      throw new Error(`Invalid resource type: ${resourceType}`);
    }

    const generator = generators[resourceType];
    if (!generator) {
      throw new Error(`No generator found for resource type: ${resourceType}`);
    }

    const doc = await generator();
    if (!doc) {
      throw new Error('PDF generation returned null');
    }

    const filename = `${resourceType.toLowerCase().replace(/\s+/g, '-')}.pdf`;
    await doc.save(filename);

    

    return true;
  } catch (error) {
    
    console.error('PDF Generation Error:', error);
    throw error;
  }
};

// Resource mapping with enhanced metadata
export const resourceMap = {
  causePortfolio: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateCausePortfolioOverview,
    title: "Cause Portfolio Management Guide",
    description: "Strategic framework for managing multiple charitable initiatives",
    type: 'pdf',
    tags: ['Operational', 'Leadership', 'Cause Management'],
    icon: <FaChartLine />,
    onClick: async () => {
      const doc = await generateCausePortfolioOverview();
      if (doc) doc.save('cause-portfolio-guide.pdf');
    }
  },
  grantFindingApplication: {
    category: resourceCategories.COMPLIANCE.id,
    type: 'pdf',
    title: "Advanced Grant Strategy Framework",
    description: "Strategic framework for developing and managing institutional grant funding",
    tags: ['Fundraising', 'Operational', 'Grants'],
    icon: <FaSearchDollar />,
    resourceType: RESOURCE_TYPES.GRANT_FINDING,
    onClick: async () => {
      const doc = await generateGrantFindingApplicationOverview();
      if (doc) doc.save('AdvancedGrantStrategyFramework.pdf');
    }
    },
  operationalCompliance: {
    category: resourceCategories.OPERATIONAL.id,
    type: 'pdf',
    title: "Operational Compliance Strategies",
    description: "Framework for nonprofit operational excellence and compliance",
    tags: ['Compliance', 'Operations'],
    icon: <FaShieldAlt />,
    resourceType: RESOURCE_TYPES.OPERATIONAL_COMPLIANCE,
    onClick: async () => {
      try {
        console.log('Generating Operational Compliance PDF...'); // Debug log
        const doc = await generateOperationalComplianceOverview();
        console.log('PDF Generated:', doc); // Debug log
        if (doc) {
          doc.save('Operational-Compliance-Framework-Guide.pdf');
        } else {
          console.error('No document returned from generator');
        }
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    }
  },
  grantPolicyReporting: {
    category: resourceCategories.COMPLIANCE.id,
    type: 'pdf',
    title: "Advanced Grant Fund Management",
    description: "Comprehensive framework for post-award excellence and compliance",
    tags: ['Compliance', 'Fundraising', 'Grants'],
    icon: <FaBalanceScale />,
    resourceType: RESOURCE_TYPES.GRANT_POLICY,
    onClick: async () => {
      const doc = await generateGrantPolicyReportingOverview();
      if (doc) doc.save('AdvancedGrantFundManagement.pdf');
    }
    },
  fundraisingStrategies: {
    category: resourceCategories.FUNDRAISING.id,
    type: 'pdf',
    title: "Fundraising Strategies Guide",
    description: "Comprehensive guide for nonprofit and fiscally sponsored fundraising",
    tags: ['Fundraising', 'Compliance'],
    icon: <FaDonate />,
    resourceType: RESOURCE_TYPES.FUNDRAISING_STRATEGIES,
    onClick: async () => {
      const doc = await generateFundraisingStrategiesOverview();
      if (doc) doc.save('FundraisingStrategiesGuide.pdf');
    }
    },
  sportsPrograms: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateSportsProgramsOverview,
    title: "Sports and Athletic Programs Guide",
    description: "Guide for managing sports programs under Fiscal Sponsorship",
    type: 'pdf',
    tags: ['Sports', 'Operations', 'Athletes' ],
    icon: <FaMedal />,
    onClick: async () => {
      const doc = await generateSportsProgramsOverview();
      if (doc) doc.save('sports-programs-guide.pdf');
    }
  },
  environmentalInitiatives: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateEnvironmentalInitiativesOverview,
    title: "Environmental Initiatives Guide",
    description: "Guide for environmental and climate initiatives",
    type: 'pdf',
    tags: ['Environmental'],
    icon: <FaLeaf />,
    onClick: async () => {
      const doc = await generateEnvironmentalInitiativesOverview();
      if (doc) doc.save('environmental-initiatives-guide.pdf');
    }
  },
  disasterRelief: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateDisasterReliefProgramsOverview,
    title: "Disaster Relief Programs Guide",
    description: "Guide for managing disaster relief programs",
    type: 'pdf',
    tags: ['Disaster'],
    icon: <FaHandHoldingHeart />,
    onClick: async () => {
      const doc = await generateDisasterReliefProgramsOverview();
      if (doc) doc.save('disaster-relief-guide.pdf');
    }
  },
  documentarists: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateDocumentaristsOverview,
    title: "Fiscal Sponsorship for Documentarists",
    description: "Funding and compliance guide for film projects",
    type: 'pdf',
    tags: ['Documentary', 'Arts', 'Operations'],
    icon: <FaFilm />,
    onClick: async () => {
      const doc = await generateDocumentaristsOverview();
      if (doc) doc.save('documentarists-guide.pdf');
    }
  },
  artsCreativeIndustries: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateArtsCreativeIndustriesOverview,
    title: "Arts & Creative Industries Guide",
    description: "Comprehensive guide for artists and creative projects",
    type: 'pdf',
    tags: ['Arts', 'Creative'],
    icon: <FaPaintBrush />,
    onClick: async () => {
      const doc = await generateArtsCreativeIndustriesOverview();
      if (doc) doc.save('arts-creative-industries-guide.pdf');
    }
  },
  scholarshipGrant: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateScholarshipGrantOverview,
    title: "Scholarship & Grant Programs Guide",
    description: "Comprehensive guide for scholarship and grant program management",
    type: 'pdf',
    tags: ['Education', 'Grants'],
    icon: <FaGraduationCap />,
    onClick: async () => {
      const doc = await generateScholarshipGrantOverview();
      if (doc) doc.save('scholarship-grant-guide.pdf');
    }
  },
  nilAthlete: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateNILFoundationOverview,
    title: "NIL Athlete Foundation Management",
    description: "Guide for managing NIL athlete foundations",
    type: 'pdf',
    tags: ['Sports', 'Compliance', 'NIL'],
    icon: <FaMedal />,
    onClick: async () => {
      const doc = await generateNILFoundationOverview();
      if (doc) doc.save('nil-athlete-guide.pdf');
    }
  },
  dynamicImpact: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateDynamicImpactOverview,
    title: "Dynamic Impact Incubators",
    description: "Guide for impact-driven program development",
    type: 'pdf',
    tags: ['Innovation', 'Impact'],
    icon: <FaLightbulb />
  },
  donorAdvisedFunds: {
    category: resourceCategories.FUNDRAISING.id,
    type: 'pdf',
    title: "Donor-Advised Funds Plus Guide",
    description: "Enhanced framework for high-impact giving with compliance and oversight",
    tags: ['Fundraising', 'Compliance', 'Operations'],
    icon: <FaDonate />,
    resourceType: RESOURCE_TYPES.DONOR_ADVISED_FUNDS,
    onClick: async () => {
      const doc = await generateDonorAdvisedFundsOverview();
      if (doc) doc.save('DonorAdvisedFundsPlusGuide.pdf');
    }
    },
  subscriptionBasedGiving: {
    category: resourceCategories.FUNDRAISING.id,
    type: 'pdf',
    title: "Subscription-Based Giving Guide",
    description: "Recurring donations made simple and impactful with automated processing",
    tags: ['Fundraising', 'Recurring Giving'],
    icon: <FaRegCalendarAlt />,
    resourceType: RESOURCE_TYPES.SUBSCRIPTION_GIVING,
    onClick: async () => {
      const doc = await generateSubscriptionBasedGivingOverview();
      if (doc) doc.save('SubscriptionBasedGivingGuide.pdf');
    }
    },
  crowdfundingFiscalSponsorship: {
    category: resourceCategories.FISCAL_SPONSORSHIP.id,
    type: 'pdf',
    title: "Crowdfunding Fiscal Sponsorship Guide",
    description: "Guide to crowdfunding with fiscal sponsorship",
    tags: ['crowdfunding', 'Fiscal Sponsorship', 'Fundraising'],
    icon: <FaUsers />,
    resourceType: RESOURCE_TYPES.CROWDFUNDING,
    onClick: async () => {
      const doc = await generateCrowdfundingFiscalSponsorshipOverview();
      if (doc) doc.save('CrowdfundingFiscalSponsorshipGuide.pdf');
    }
    },

  communityBasedPrograms: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateCommunityBasedProgramsOverview,
    title: "Community-Based Programs Guide",
    description: "Guide for developing community-based programs",
    type: 'pdf',
    tags: ['Community', 'Programs', 'Operations'],
    icon: <FaUsers />,
    onClick: async () => {
      const doc = await generateCommunityBasedProgramsOverview();
      if (doc) doc.save('community-programs-guide.pdf');
    }
  },
  afterSchoolEducation: {
    category: resourceCategories.EDUCATIONAL.id,
    type: 'pdf',
    title: "After-School Education Programs",
    description: "Guide for managing after-school education programs",
    tags: ['Education', 'Youth', 'Operations'],
    icon: <FaSchool />,
    resourceType: RESOURCE_TYPES.AFTER_SCHOOL,
    onClick: async () => {
      const doc = await generateAfterSchoolEducationProgramsOverview();
      if (doc) doc.save('AfterSchoolEducationPrograms.pdf');
    }
  },
  strategicPartnerships: {
    category: resourceCategories.OPERATIONAL.id,
    type: 'pdf',
    title: "Strategic Partnerships and Alliances",
    description: "Guide to building strategic partnerships and alliances",
    tags: ['Partnerships', 'Growth'],
    icon: <FaHandshake />,
    resourceType: RESOURCE_TYPES.STRATEGIC_PARTNERSHIPS,
    onClick: async () => {
      const doc = await generateStrategicPartnershipsOverview();
      if (doc) doc.save('StrategicPartnerships.pdf');
    }
  },
  technologySolutions: {
    category: resourceCategories.OPERATIONAL.id,
    type: 'pdf',
    title: "Next-Generation Technology Framework",
    description: "Strategic guide to next-generation technology infrastructure",
    tags: ['Technology', 'Innovation'],
    icon: <FaLaptopCode />,
    resourceType: RESOURCE_TYPES.TECHNOLOGY_SOLUTIONS,
    onClick: async () => {
      const doc = await generateTechnologySolutionsOverview();
      if (doc) doc.save('NextGenTechnologySolutions.pdf');
     }
    },
  fiscalSponsorship: {
    category: resourceCategories.FISCAL_SPONSORSHIP.id,
    type: 'pdf',
    title: "Fiscal Sponsorship Models",
    description: "An overview of the most common fiscal sponsorship models",
    tags: ['Fiscal Sponsorship', 'Compliance'],
    icon: <FaRegBuilding />,
    resourceType: RESOURCE_TYPES.FISCAL_SPONSORSHIP,
    onClick: async () => {
      const doc = await generateFiscalSponsorshipOverview();
      if (doc) doc.save('FiscalSponsorshipModels.pdf');
    }
    },
  corporatePhilanthropy: {
    category: resourceCategories.FUNDRAISING.id,
    type: 'pdf',
    title: "Corporate Social Responsibility & Philanthropy Guide",
    description: "Comprehensive guide to strategic corporate giving and CSR implementation",
    tags: ['Corporate Giving', 'CSR', 'Compliance'],
    icon: <FaBuilding />,
    resourceType: RESOURCE_TYPES.CORPORATE_PHILANTHROPY,
    onClick: async () => {
      const doc = await generateCorporatePhilanthropyOverview();
      if (doc) doc.save('CorporateSocialResponsibilityPhilanthropyGuide.pdf');
    }
    },
  nilFiscalSponsorshipGuide: {
    category: resourceCategories.FISCAL_SPONSORSHIP.id,
    type: 'pdf',
    title: "NIL Fiscal Sponsorship Guide",
    description: "Comprehensive guide to NIL fiscal sponsorship for athletes and nonprofits",
    tags: ['NIL', 'Fiscal Sponsorship', 'Athletes', 'Compliance'],
    icon: <FaMedal />,
    resourceType: RESOURCE_TYPES.NIL_GUIDE,
    onClick: async () => {
      const doc = await generateNILFiscalSponsorshipGuide();
      if (doc) doc.save('NILFiscalSponsorshipGuide.pdf');
    }
    },
  fiscalSponsorshipDefinitiveGuide: {
    category: resourceCategories.FISCAL_SPONSORSHIP.id,
    type: 'pdf',
    title: "The Definitive Guide to Modern Fiscal Sponsorship",
    description: "Revolutionary guide redefining fiscal sponsorship for the digital age, introducing pioneering frameworks for compliance, risk management, and scaled impact.",
    tags: [
      'Fiscal Sponsorship',
      'Compliance',
      'Innovation',
      'Risk Management',
      'Cause Management',
      'Technology Integration'
    ],
    icon: <FaBookOpen />,
    featured: true, // Mark as featured resource
    resourceType: RESOURCE_TYPES.FISCAL_SPONSORSHIP_DEFINITIVE,
    onClick: async () => {
      const doc = await generateFiscalSponsorshipDefinitiveGuide();
      if (doc) doc.save('DefinitiveGuideToModernFiscalSponsorship.pdf');
    }
    },
  medicalResearch: {
    category: resourceCategories.EDUCATIONAL.id,
    generator: generateMedicalResearchOverview,
    title: "Medical Research Fiscal Sponsorship Guide",
    description: "Comprehensive guide for medical research projects and clinical trials",
    type: 'pdf',
    tags: ['Medical', 'Research', 'Compliance', 'Operations'],
    icon: <FaHeartbeat />,
    onClick: async () => {
      const doc = await generateMedicalResearchOverview();
      if (doc) doc.save('medical-research-guide.pdf');
    }
  },
  accountingGuidance: {
    category: resourceCategories.OPERATIONAL.id,
    generator: generateAccountingGuidanceOverview,
    title: "Nonprofit Accounting & Compliance Guide",
    description: "Essential guidance for nonprofit accounting and financial compliance",
    type: 'pdf',
    tags: ['Accounting', 'Compliance', 'Operations', 'Financial'],
    icon: <FaCalculator />,
    onClick: async () => {
      const doc = await generateAccountingGuidanceOverview();
      if (doc) doc.save('accounting-guidance.pdf');
    }
  },
  charitableRemainderFunds: {
    category: resourceCategories.OPERATIONAL.id,
    generator: generateCRFGuide,
    type: 'pdf',
    title: "Guide to Charitable Remainder Funds",
    description: "Comprehensive guide to managing charitable remainder funds",
    tags: ['Charitable Giving', 'Estate Planning', 'Tax Benefits', 'Legacy Planning', 'Retirement'],
    icon: <GiTakeMyMoney />,
    onClick: async () => {
      const doc = await generateCRFGuide();
      if (doc) {
        doc.save('CharitableRemainderFundsGuide.pdf');
      }
    }
  }
};

// Enhanced resource retrieval with error handling
export const getResourcesByCategory = (categories) => {
  if (!Array.isArray(categories)) {
    categories = [categories];
  }
  return Object.values(resourceMap).filter(resource => 
    categories.some(category => resource.category === category)
  );
};

// Utility function to get featured resources
export const getFeaturedResources = (limit = 6) => {
  try {
    return Object.entries(resourceMap)
      .filter(([_, resource]) => resource.featured)
      .slice(0, limit)
      .map(([key, resource]) => ({
        ...resource,
        id: key,
        onClick: async (e) => {
          e.preventDefault();
          await handlePDFGeneration(resource.generator, resource.title);
        }
      }));
  } catch (error) {
    console.error('Error retrieving featured resources:', error);
    return [];
  }
};

// Search functionality
export const searchResources = (query) => {
  try {
    const searchTerm = query.toLowerCase();
    return Object.entries(resourceMap)
      .filter(([_, resource]) => {
        const searchableText = `${resource.title} ${resource.description} ${resource.tags.join(' ')}`.toLowerCase();
        return searchableText.includes(searchTerm);
      })
      .map(([key, resource]) => ({
        ...resource,
        id: key,
        onClick: async (e) => {
          e.preventDefault();
          try {
            

            // Handle both direct generator functions and resourceType-based generation
            if (resource.resourceType) {
              await handlePDFGeneration(resource.resourceType);
            } else if (resource.generator) {
              const doc = await resource.generator();
              if (doc) {
                const filename = `${key.toLowerCase().replace(/\s+/g, '-')}.pdf`;
                doc.save(filename);
              }
            }

          } catch (error) {
            console.error('PDF Generation Error:', error);
            
            throw error;
          }
        }
      }));
  } catch (error) {
    console.error('Search Error:', error);
    return [];
  }
};

// Resource categories with their respective resources
export const resources = {
  educational: [
    {
      id: 'cause-portfolio',
      title: 'Cause Portfolio Management Guide',
      description: 'Strategic framework for managing multiple charitable initiatives',
      type: 'pdf',
      tags: ['Operational', 'Leadership', 'Cause Management'],
      icon: <FaChartLine />,
      onClick: async () => {
        const doc = await generateCausePortfolioOverview();
        if (doc) doc.save('cause-portfolio-guide.pdf');
      }
    },
    {
      id: 'sports-programs',
      title: 'Sports Programs Guide',
      description: 'Guide for managing sports programs',
      type: 'pdf',
      tags: ['Sports', 'Operations', 'Athletes'],
      icon: <FaMedal />,
      onClick: async () => {
        const doc = await generateSportsProgramsOverview();
        if (doc) doc.save('sports-programs-guide.pdf');
      }
    },
    {
      id: 'environmental-initiatives',
      title: 'Environmental Initiatives Guide',
      description: 'Guide for environmental and climate initiatives',
      type: 'pdf',
      tags: ['Environmental'],
      icon: <FaLeaf />,
      onClick: async () => {
        const doc = await generateEnvironmentalInitiativesOverview();
        if (doc) doc.save('environmental-initiatives-guide.pdf');
      }
    },
    {
      id: 'disaster-relief',
      title: 'Disaster Relief Programs Guide',
      description: 'Guide for managing disaster relief programs',
      type: 'pdf',
      tags: ['Disaster'],
      icon: <FaHandHoldingHeart />,
      onClick: async () => {
        const doc = await generateDisasterReliefProgramsOverview();
        if (doc) doc.save('disaster-relief-guide.pdf');
      }
    },
    {
      id: 'documentarists',
      title: 'Fiscal Sponsorship for Documentarists',
      description: 'Funding and compliance guide for film projects',
      type: 'pdf',
      tags: ['Documentary', 'Arts', 'Operations'],
      icon: <FaFilm />,
      onClick: async () => {
        const doc = await generateDocumentaristsOverview();
        if (doc) doc.save('documentarists-guide.pdf');
      }
    },
    {
      id: 'arts-creative-industries',
      title: 'Arts & Creative Industries Guide',
      description: 'Comprehensive guide for artists and creative projects',
      type: 'pdf',
      tags: ['Arts', 'Creative'],
      icon: <FaPaintBrush />,
      onClick: async () => {
        const doc = await generateArtsCreativeIndustriesOverview();
        if (doc) doc.save('arts-creative-industries-guide.pdf');
      }
    },
    {
      id: 'scholarship-grant',
      title: 'Scholarship & Grant Programs Guide',
      description: 'Comprehensive guide for scholarship and grant program management',
      type: 'pdf',
      tags: ['Education', 'Grants'],
      icon: <FaGraduationCap />,
      onClick: async () => {
        const doc = await generateScholarshipGrantOverview();
        if (doc) doc.save('scholarship-grant-guide.pdf');
      }
    },
    {
      id: 'nil-athlete',
      title: 'NIL Athlete Foundation Management',
      description: 'Guide for managing NIL athlete foundations',
      type: 'pdf',
      tags: ['Sports', 'Compliance'],
      icon: <FaMedal />,
      onClick: async () => {
        const doc = await generateNILFoundationOverview();
        if (doc) doc.save('nil-athlete-guide.pdf');
      }
    },
    {
      id: 'after-school-education',
      title: 'After-School Education Programs',
      description: 'Guide for managing after-school education programs',
      type: 'pdf',
      tags: ['Education', 'Youth'],
      icon: <FaSchool />,
      onClick: () => handlePDFGeneration(RESOURCE_TYPES.AFTER_SCHOOL)
    },
    {
      id: 'medical-research',
      title: 'Medical Research Fiscal Sponsorship Guide',
      description: 'Comprehensive guide for medical research projects and clinical trials',
      type: 'pdf',
      tags: ['Medical', 'Research', 'Compliance', 'Operations'],
      icon: <FaHeartbeat />,
      onClick: async () => {
        const doc = await generateMedicalResearchOverview();
        if (doc) doc.save('medical-research-guide.pdf');
      }
    },
    {
      id: 'accounting-guidance',
      title: 'Nonprofit Accounting & Compliance Guide',
      description: 'Essential guidance for nonprofit accounting and financial compliance',
      type: 'pdf',
      tags: ['Accounting', 'Compliance', 'Operations', 'Financial'],
      icon: <FaCalculator />,
      onClick: async () => {
        const doc = await generateAccountingGuidanceOverview();
        if (doc) doc.save('accounting-guidance.pdf');
      }
    }
  ],
  operational: [
    {
      id: 'operational-compliance',
      title: 'Operational Compliance Strategies',
      description: 'Framework for nonprofit operational excellence and compliance',
      type: 'pdf',
      tags: ['Compliance', 'Operations'],
      icon: <FaShieldAlt />,
      resourceType: RESOURCE_TYPES.OPERATIONAL_COMPLIANCE,
      onClick: async () => {
        try {
          console.log('Generating Operational Compliance PDF...'); // Debug log
          const doc = await generateOperationalComplianceOverview();
          console.log('PDF Generated:', doc); // Debug log
          if (doc) {
            doc.save('Operational-Compliance-Framework-Guide.pdf');
          } else {
            console.error('No document returned from generator');
          }
        } catch (error) {
          console.error('Error generating PDF:', error);
        }
      }
    },
    {
      id: 'strategic-partnerships',
      title: 'Strategic Partnerships and Alliances',
      description: 'Guide to building strategic partnerships and alliances',
      type: 'pdf',
      tags: ['Partnerships', 'Growth'],
      icon: <FaHandshake />,
      resourceType: RESOURCE_TYPES.STRATEGIC_PARTNERSHIPS,
      onClick: () => handlePDFGeneration(RESOURCE_TYPES.STRATEGIC_PARTNERSHIPS)
    },
    {
      id: 'technology-solutions',
      title: 'Next-Generation Technology Framework',
      description: 'Strategic guide to next-generation technology infrastructure',
      type: 'pdf',
      tags: ['Technology', 'Innovation'],
      icon: <FaLaptopCode />,
      resourceType: RESOURCE_TYPES.TECHNOLOGY_SOLUTIONS,
      onClick: () => handlePDFGeneration(RESOURCE_TYPES.TECHNOLOGY_SOLUTIONS)
    }
  ],
  compliance: [
    {
      id: 'grant-finding',
      title: 'Advanced Grant Strategy Framework',
      description: 'Strategic framework for developing and managing institutional grant funding',
      type: 'pdf',
      tags: ['Fundraising', 'Operational'],
      icon: <FaSearchDollar />,
      resourceType: RESOURCE_TYPES.GRANT_FINDING,
      onClick: async () => {
        const doc = await generateGrantFindingApplicationOverview();
        if (doc) doc.save('AdvancedGrantStrategyFramework.pdf');
       }
      },
    {
      id: 'grant-policy-reporting',
      title: 'Advanced Grant Fund Management',
      description: 'Comprehensive framework for post-award excellence and compliance',
      type: 'pdf',
      tags: ['Compliance', 'Fundraising'],
      icon: <FaBalanceScale />,
      resourceType: RESOURCE_TYPES.GRANT_POLICY,
      onClick: async () => {
        const doc = await generateGrantPolicyReportingOverview();
        if (doc) doc.save('GrantPolicyReporting.pdf');
      }
    },
  ],
  fundraising: [
    {
      id: 'fundraising-strategies',
      title: 'Fundraising Strategies Guide',
      description: 'Comprehensive guide for nonprofit and fiscally sponsored fundraising',
      type: 'pdf',
      tags: ['Fundraising', 'Compliance'],
      icon: <FaDonate />,
      resourceType: RESOURCE_TYPES.FUNDRAISING_STRATEGIES,
      onClick: () => handlePDFGeneration(RESOURCE_TYPES.FUNDRAISING_STRATEGIES)
    },
    {
      id: 'donor-advised-funds',
      title: 'Donor-Advised Funds Plus Guide',
      description: 'Enhanced framework for high-impact giving with compliance and oversight',
      type: 'pdf',
      tags: ['Fundraising', 'Compliance'],
      icon: <FaDonate />,
      resourceType: RESOURCE_TYPES.DONOR_ADVISED_FUNDS,
      onClick: () => handlePDFGeneration(RESOURCE_TYPES.DONOR_ADVISED_FUNDS)
    },
    {
      id: 'subscription-based-giving',
      title: 'Subscription-Based Giving Guide',
      description: 'Recurring donations made simple and impactful with automated processing',
      type: 'pdf',
      tags: ['Fundraising', 'Recurring Giving'],
      icon: <FaRegCalendarAlt />,
      resourceType: RESOURCE_TYPES.SUBSCRIPTION_GIVING,
      onClick: async () => {
        const doc = await generateSubscriptionBasedGivingOverview();
        if (doc) doc.save('SubscriptionBasedGivingGuide.pdf');
      }
      },
    {
      id: 'corporate-philanthropy',
      title: 'Corporate Social Responsibility & Philanthropy Guide',
      description: 'Comprehensive guide to strategic corporate giving and CSR implementation',
      type: 'pdf',
      tags: ['Corporate Giving', 'CSR', 'Compliance'],
      icon: <FaBuilding />,
      resourceType: RESOURCE_TYPES.CORPORATE_PHILANTHROPY,
      onClick: async () => {
        const doc = await generateCorporatePhilanthropyOverview();
        if (doc) doc.save('CorporateSocialResponsibilityPhilanthropyGuide.pdf');
      }
      },
  ],
  fiscal_sponsorship: [
    {
      id: 'fiscal-sponsorship',
      title: 'Fiscal Sponsorship Guide',
      description: 'Comprehensive guide to fiscal sponsorship',
      type: 'pdf',
      tags: ['Fiscal Sponsorship', 'Compliance'],
      icon: <FaRegBuilding />,
      resourceType: RESOURCE_TYPES.FISCAL_SPONSORSHIP,
      onClick: () => handlePDFGeneration(RESOURCE_TYPES.FISCAL_SPONSORSHIP)
    },
    {
      id: 'crowdfunding-fiscal-sponsorship',
      title: 'Crowdfunding Fiscal Sponsorship Guide',
      description: 'Comprehensive guide to compliant crowdfunding with fiscal sponsorship',
      type: 'pdf',
      tags: ['Crowdfunding', 'Fiscal Sponsorship', 'Compliance'],
      icon: <FaUsers />,
      resourceType: RESOURCE_TYPES.CROWDFUNDING,
      onClick: () => handlePDFGeneration(RESOURCE_TYPES.CROWDFUNDING)
    },
    {
      id: 'nil-fiscal-sponsorship-guide',
      title: 'NIL Fiscal Sponsorship Guide',
      description: 'Comprehensive guide to NIL fiscal sponsorship for athletes and nonprofits',
      type: 'pdf',
      tags: ['NIL', 'Fiscal Sponsorship', 'Athletes', 'Compliance'],
      icon: <FaMedal />,
      resourceType: RESOURCE_TYPES.NIL_GUIDE,
      onClick: () => handlePDFGeneration(RESOURCE_TYPES.NIL_GUIDE)
    },
    {
      id: 'fiscal-sponsorship-definitive-guide',
      title: 'The Definitive Guide to Modern Fiscal Sponsorship',
      description: 'Revolutionary guide redefining fiscal sponsorship for the digital age, introducing pioneering frameworks for compliance, risk management, and scaled impact.',
      type: 'pdf',
      tags: [
        'Fiscal Sponsorship',
        'Compliance',
        'Innovation',
        'Risk Management',
        'Cause Management',
        'Technology Integration'
      ],
      icon: <FaBookOpen />,
      resourceType: RESOURCE_TYPES.FISCAL_SPONSORSHIP_DEFINITIVE,
      onClick: () => handlePDFGeneration(RESOURCE_TYPES.FISCAL_SPONSORSHIP_DEFINITIVE)
    }
  ]
};

// Export utility functions for resource management
export const ResourceUtils = {
    getCategoryIcon: (categoryId) => {
      switch(categoryId) {
        case 'ACCOUNTING':
          return <FaCalculator />;
        case 'ARTS':
          return <FaPalette />;
        case 'ATHLETES':
          return <FaMedal />;
        case 'CSR':
          return <FaHandshake />;
        case 'CAUSE MANAGEMENT':
        case 'CAUSE_MANAGEMENT':
          return <FaHeart />;
        case 'COMMUNITY':
          return <FaUsers />;
        case 'CREATIVE':
          return <FaPaintBrush />;
        case 'DISASTER':
          return <FaHandHoldingHeart />;
        case 'DOCUMENTARY':
          return <FaFilm />;
        case 'ENVIRONMENTAL':
          return <FaLeaf />;
        case 'TECHNOLOGY':
          return <FaComputer />;
        case 'TECHNOLOGY_INTEGRATION':
        case 'TECHNOLOGY INTEGRATION':
          return <GiTechnoHeart  />;
        case 'PROGRAMS':
          return <FaProjectDiagram />;
        case 'YOUTH':
          return <FaChild />;
          case 'GRANTS':
        return <FaHandHoldingUsd />;
      case 'GROWTH':
        return <FaChartLine />;
      case 'IMPACT':
        return <FaBullseye />;
      case 'INNOVATION':
        return <FaLightbulb />;
      case 'LEADERSHIP':
        return <FaUserTie />;
      case 'MEDICAL':
        return <FaHeartbeat />;
      case 'NIL':
        return <FaMedal />;
      case 'PARTNERSHIPS':
        return <FaHandshake />;
      case 'RECURRING_GIVING':
      case 'RECURRING GIVING':
        return <FaRegCalendarAlt />;
      case 'RESEARCH':
        return <FaSearch />;
      case 'RISK_MANAGEMENT':
      case 'RISK MANAGEMENT':
        return <FaShieldAlt />;
      case 'SPORTS':
        return <FaRunning />;
      case 'CORPORATE_GIVING':
      case 'CORPORATE GIVING':
        return <FaBuilding />;
      case 'CROWDFUNDING':
        return <FaUsers />;
        case 'FINANCIAL':
          return <FaMoneyBillWave />;
        case 'FISCAL SPONSORSHIP':
          return <GiSurroundedShield />;
        case 'EDUCATION':
          return <PiStudentBold />;
        case 'OPERATIONS':
          return <FaHardHat />;
        default:
          return resourceCategories[categoryId]?.icon || <FaBookOpen />;
      }
    },
  getCategoryTitle: (categoryId) => resourceCategories[categoryId]?.title || 'Unknown Category',
  getCategoryDescription: (categoryId) => resourceCategories[categoryId]?.description || '',
  getResourceCount: (categoryId) => getResourcesByCategory(categoryId).length,
  isValidCategory: (categoryId) => Object.keys(resourceCategories).includes(categoryId.toUpperCase()),
  getResourceTags: () => {
    const tags = new Set();
    Object.values(resourceMap).forEach(resource => {
      if (resource.tags) {
        resource.tags.forEach(tag => tags.add(tag));
      }
    });
    return Array.from(tags).sort();
  },
  filterByTags: (tags) => {
    try {
      return Object.entries(resourceMap)
        .map(([key, resource]) => ({
          ...resource,
          id: key
        }))
        .filter(resource => {
          // Check if any of the selected tags match the resource tags
          return tags.some(tag => 
            resource.tags && resource.tags.map(t => t.toLowerCase())
              .includes(tag.toLowerCase())
          );
        })
        .map(resource => ({
          ...resource,
          onClick: async (e) => {
            e.preventDefault();
            try {
              if (resource.generator) {
                const doc = await resource.generator();
                if (doc) doc.save(`${resource.id}-guide.pdf`);
              } else if (resource.resourceType) {
                await handlePDFGeneration(resource.resourceType);
              } else {
                console.error('No generator or resourceType found for:', resource.title);
              }
            } catch (error) {
              console.error('Error generating PDF:', error);
            }
          }
        }));
    } catch (error) {
      console.error('Error filtering resources by tags:', error);
      return [];
    }
  }
}; 